import { Injectable } from '@angular/core'
import { HttpService } from '@surgetech-eu/core'
import { Observable } from 'rxjs'
import { ComponentTypeModel } from '../models'
import { MainPart } from './main-part.service'

export interface ComponentType extends ComponentTypeModel {
    key?: string
    new?: boolean
}

const url = `/libraries/management/types/componentType/entries`

@Injectable()
export class ComponentTypeService {
    constructor(private http: HttpService) {}

    getAll(): Observable<ComponentType[]> {
        return this.http.get<ComponentType[]>(url)
    }

    remove(data: ComponentType[]): Observable<void> {
        return this.http.delete(url, { data })
    }

    create(data: ComponentType[]): Observable<ComponentType[]> {
        return this.http.post<ComponentType[]>(url, { data })
    }
    update(data: ComponentType[]): Observable<ComponentType[]> {
        return this.http.put<ComponentType[]>(url, { data })
    }
}
